import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router';

import { apiClient } from '../api-client.ts';
import type { NamePatternDto, NamePatternDtoTypeEnum } from '../types';

export const useNamePatternDetail = (
  type: NamePatternDtoTypeEnum,
  overrideName: string | undefined,
) => {
  const { projectId } = useParams();

  return useQuery<NamePatternDto[]>({
    queryKey: ['name-patterns', projectId, type, 'detail', overrideName],
    queryFn: () =>
      apiClient.get(
        `/v1/projects/${projectId}/name-patterns/${type}/${encodeURIComponent(overrideName!)}`,
      ),
    enabled: !!projectId && !!overrideName,
  });
};
